import { AxiosRequestConfig } from 'axios';

import { ProductType } from '../../../common';
import { getFetchPricesUrl, getFetchSFCCPricesUrlByIds } from '../../utilities';
import { getPricingHeaders } from '../../utilities/get-price-headers';
import { getPricingApiConfig, pricingHttp } from '../pricing-api';

export const getPricesByIds = async <T>(
  entityIds: number[],
  productType: ProductType
): Promise<T | null> => {
  const { isSFCCPricingOn, shopApiClientId } = getPricingApiConfig();
  let url: string;
  let requestConfig: AxiosRequestConfig = {};
  if (isSFCCPricingOn) {
    url = getFetchSFCCPricesUrlByIds(entityIds, productType);
    requestConfig = await getPricingHeaders(shopApiClientId);
  } else {
    url = getFetchPricesUrl(entityIds, productType);
  }

  const response = await pricingHttp.get<T>(url, requestConfig);
  return response.data;
};
